import { useEffect } from 'react';
import { useTonAddress } from '@tonconnect/ui-react';
import { useTranslation } from 'react-i18next';
import { api } from '@/api/endpoints';
import { useAuth } from '@/store/auth';
import { useUI } from '@/store/ui';

/**
 * Когда TonConnect устанавливает кошелёк — синхронизируем адрес в бэк
 * и обновляем `auth.user.ton_wallet`. Безопасно вызывать на нескольких
 * экранах: запросы идут только при реальной смене адреса.
 */
export function useTonWalletSync(): void {
  const user = useAuth(s => s.user);
  const patchUser = useAuth(s => s.patchUser);
  const showToast = useUI(s => s.showToast);
  const { t } = useTranslation();
  const tonAddress = useTonAddress();

  useEffect(() => {
    if (!tonAddress || user?.ton_wallet === tonAddress) return;
    api.wallet.connect(tonAddress)
      .then(() => patchUser({ ton_wallet: tonAddress }))
      .catch(() => showToast(t('profile.wallet_save_error'), 'error'));
  }, [tonAddress, user?.ton_wallet, patchUser, showToast, t]);
}
